import React, { useState } from "react";
import "./styles.css";
import { AiOutlineSearch } from "react-icons/ai";
import { IoIosArrowDown } from "react-icons/io";
import { Collapse } from "react-collapse";
import FormRIPacientesCadastro from './../../../components/Forms_RepresentanteDeInstituição/Tela_RI_Pacientes_Cadastro';
import { NavLink } from 'react-router-dom';
import SideNav from './../../../components/SideNav';

export default function RI_PacientesCadastro() {
    let [search, setSearch] = useState(false);
    let [options, setOptions] = useState(false);
    return (
        <>
            <SideNav />
            <div id="top-RI-Cadastro">
                <NavLink id="RI-cadastro" to="/RI_Painel"><button id="exit-RI-Cadastro">Voltar</button></NavLink>
                <div style={{ display: "flex", flexDirection: "row" }}>
                    <Collapse isOpened={search}>
                        <input id="RI-Cadastro-Search" placeholder="pesquisar..." />
                    </Collapse>
                    <AiOutlineSearch
                        size={"6vh"}
                        onClick={() =>
                            setSearch(!search)
                        }
                        id="Icon-Search-RI-Cadastro"
                    />
                </div>
            </div>
            <div id="main-RI-Detalhes-Paciente">
                <p id="RI-Detalhes-Paciente">Cadastro de pacientes</p> 
                <hr id="divider-RI-Detalhes-Paciente" />
                <div id="arrow-RI-Detalhes-Paciente">
                        <IoIosArrowDown
                            onClick={() =>
                                setOptions(!options)
                            }
                            size={"6vh"}
                            id="IconDown-RI-Detalhes-Paciente"
                        />
                    </div>
                    <Collapse isOpened={options}>
                        <FormRIPacientesCadastro />
                    </Collapse>
            </div>
        </>
    );
}